module.exports = __webpack_public_path__ + "img/tr.f80e6ae7.png";